import { render, staticRenderFns } from "./Cg.vue?vue&type=template&id=18ada44e&"
import script from "./Cg.vue?vue&type=script&lang=js&"
export * from "./Cg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports